import { Logo as LogoComponent } from '@components'

import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${Spacing.S32};
`

export const Logo = styled(LogoComponent)`
  margin-bottom: ${Spacing.S32};
`

export const TermsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${Spacing.S16};
`
